var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blc-color pop-800"
  }, [_vm._v("Rýchle odpovede")])]), _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "quick-response-block pointer",
    on: {
      "click": function click($event) {
        _vm.setQuickResponse('Dobrý deň, poradím Vám s výberom riešenia? Ak Vám fixácia končí neskôr, už dnes vieme podchytiť úrokové sadzby (napr. UniCreditBank 3.89%) s čerpaním do 1 roka tak, aby sme sa vyhli pokute.');
      }
    }
  }, [_vm._v(" Dobrý deň, poradím Vám s výberom riešenia? Ak Vám fixácia končí neskôr, už dnes vieme podchytiť úrokové sadzby (napr. UniCreditBank 3.89%) s čerpaním do 1 roka tak, aby sme sa vyhli pokute. ")]), _c('div', {
    staticClass: "quick-response-block pointer",
    on: {
      "click": function click($event) {
        return _vm.setQuickResponse('Dobrý deň, vieme Vám pomôcť s výberom správnej banky? V prípade ak už máte vybranú nehnuteľnosť, tak Vám náš advokát skontroluje zadarmo zmluvy. Len dajte vedieť, Petrovič.');
      }
    }
  }, [_vm._v(" Dobrý deň, vieme Vám pomôcť s výberom správnej banky? V prípade ak už máte vybranú nehnuteľnosť, tak Vám náš advokát skontroluje zadarmo zmluvy. Len dajte vedieť, Petrovič. ")]), _c('div', {
    staticClass: "quick-response-block pointer",
    on: {
      "click": function click($event) {
        return _vm.setQuickResponse('Schválenie hypotéky trvá štandardne 2 až 3 pracovné dní od skompletizivania žiadosti.');
      }
    }
  }, [_vm._v(" Schválenie hypotéky trvá štandardne 2 až 3 pracovné dní od skompletizivania žiadosti. ")]), _c('div', {
    staticClass: "quick-response-block pointer",
    on: {
      "click": function click($event) {
        return _vm.setQuickResponse('Dobrý deň, vieme Vám pomôcť s výberom správnej banky?');
      }
    }
  }, [_vm._v(" Dobrý deň, vieme Vám pomôcť s výberom správnej banky? ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }